import axios from '@/utils/axios'

export const getSalesLatestCost = (payload) => {
    return axios.get('/sales_latest_cost', {
        params: payload
    })
}

export const getCalcSalesCost = (payload) => {
    return axios.get('/calc_sales_cost', {
        params: payload
    })
}

export const getCalcSalesCostByID = (id) => {
    return axios.get(`/calc_sales_cost/${id}`)
}

export const getCalcSalesCostAnalyzeByID = (id, payload) => {
    return axios.get(`/calc_sales_cost_analyze/${id}`, {
        params: payload
    })
}

export const calcSalesCostById = (payload) => {
    return axios.post('/calc_sales_cost_by_id', payload)
}

export const calcAllSalesCost = (payload) => {
    return axios.post('/calc_all_sales_cost', payload)
}